module.exports = __webpack_public_path__ + "img/feedback_active.71fa63e3.svg";